// 活动报名接口
import ajax from '@/utils/ajax'

/**
 * 天天特价活动报名
 */

// 获取油站信息
export const gasDetail = params => ajax.post('activity/gasDetail', params)

// 让利以及置顶范围
export const getWallConfig = params => ajax.post('activity/wallConfig', params)

// 获取油号以及枪价
export const oilConfig = params => ajax.post('activity/oilConfig', params)

// 天天特价表单提交
export const submitDaySpecial = params => ajax.post('activity/submit', params)

// 获取协议
export const getProtocol = params => ajax.post('marketTask/haveReadAndProtocolContentV2', params)

// 添加营销任务电子协议阅读记录
export const addReadRead = params => ajax.post('marketTask/addReadReadV2', params)
